export const CREDIT_EXCEED_ERROR_CODE = 'NO_CREDITS';